import React from 'react';

import styles from './Header.module.css';

const Header = () => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                Law enforcement agencies across the country are failing to provide us with even basic information about the lives they take. So we collect the data ourselves.
                <br />
                <span className={styles.cta}>Scroll to explore.</span>
            </div>
        </div>
    )
}

export default Header